export const validateForm = async (payload, validationSchema) => {
  const errors = {};

  await validationSchema
    .validate(payload, { abortEarly: false })
    .then(() => {})
    .catch((err) => {
      err.inner.forEach((e) => {
        errors[e.path] = e.message;
        return;
      });
    });

  return errors;
};

export const validate = async (value, field) => {
  let payload = {};
  payload[field] = value;
  const error = await validateForm(payload);
  return error[field];
};
